(function () {
  const MIN_WINE_QTY = 2;

  function shakeNotice(notice) {
    notice.style.animation = 'none';
    requestAnimationFrame(function () {
      notice.style.animation = 'minOrderShake 0.4s ease';
    });
  }

  // Cart page: reads from hidden element inside .js-contents, which re-renders on qty changes.
  // Returns null if not on cart page.
  function getCartPageWineQty() {
    const el = document.getElementById('cart-footer-wine-qty');
    return el ? parseInt(el.getAttribute('data-wine-qty') || '0', 10) : null;
  }

  // Notification: fetch live cart and count wine items using the pre-seeded product ID set.
  function fetchWineQty() {
    const wineIds = window.wineProductIds;
    if (!wineIds || wineIds.size === 0) return Promise.resolve(0);
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return cart.items
          .filter(function (item) { return wineIds.has(item.product_id); })
          .reduce(function (sum, item) { return sum + item.quantity; }, 0);
      })
      .catch(function () { return 0; });
  }

  // Cart page checkout button — sync check from Liquid-rendered data.
  document.addEventListener('click', function (e) {
    const button = e.target.closest('button[name="checkout"]');
    // Skip — notification form handles its own submit event below.
    if (!button || button.closest('#cart-notification-form')) return;

    const wineQty = getCartPageWineQty();
    if (wineQty === null || wineQty === 0 || wineQty >= MIN_WINE_QTY) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const notice = button.closest('.cart__ctas') &&
      button.closest('.cart__ctas').querySelector('.cart__min-order-notice');
    if (!notice) return;
    notice.classList.add('cart__min-order-notice--warning');
    shakeNotice(notice);
  }, true);

  // Cart notification checkout form — async check via /cart.js.
  var notificationApproved = false;

  document.addEventListener('submit', function (e) {
    if (e.target.id !== 'cart-notification-form') return;
    if (notificationApproved) { notificationApproved = false; return; }

    e.preventDefault();
    e.stopImmediatePropagation();

    var form = e.target;
    var submitter = e.submitter;
    var notice = document.getElementById('cart-notification-min-order');

    fetchWineQty().then(function (wineQty) {
      if (wineQty === 0 || wineQty >= MIN_WINE_QTY) {
        notificationApproved = true;
        form.requestSubmit(submitter);
      } else {
        if (notice) {
          notice.removeAttribute('hidden');
          shakeNotice(notice);
        }
      }
    });
  }, true);
})();
